import { HttpStatusCode } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { requestApi } from './helpers/request-api';
import { validate } from './helpers/validate';
export function createAPIDefinition(...args) {
    return (async (request, progressEventCallBack) => {
        var _a, _b;
        /**
         * args[0] is the internal configs
         * args[1] is the global configs which is used only internally inside apiFactory and excluded from the external usage and types
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const config = Object.assign(Object.assign({}, (_a = args === null || args === void 0 ? void 0 : args[1]) === null || _a === void 0 ? void 0 : _a.call(args)), args[0]);
        const hasHeadersOrParameters = config.requestParameters || config.requestHeaders;
        const requestBody = hasHeadersOrParameters ? request.body : request;
        const requestId = uuidv4();
        const requestParameters = hasHeadersOrParameters
            ? request.parameters
            : undefined;
        const requestHeaders = hasHeadersOrParameters ? request.headers : undefined;
        const { method = 'GET', responseSchema, originalResponseSchema, url, baseUrl, headers = {}, validationMode = 'Warning', transformError, transformResponse, isErrorResponse = ({ status }) => status >= HttpStatusCode.BadRequest, refreshToken, timeout, retryConfig, responseType, } = config;
        if (!method && method !== 'GET') {
            if (!requestBody)
                throw Error('[API] request body is required');
            validate({
                requestId,
                validationMode,
                url,
                validationSchema: config.requestSchema,
                code: 'InvalidRequestSchema',
                data: requestBody,
            });
        }
        const { data: originalResponse, status, headers: responseHeader, } = await requestApi(baseUrl, headers, requestHeaders, requestParameters, url, method, requestBody, refreshToken, requestId, timeout, responseType, retryConfig, progressEventCallBack);
        validate({
            requestId,
            validationMode,
            url,
            validationSchema: originalResponseSchema,
            code: 'InvalidOriginalResponseSchema',
            data: originalResponse,
            status,
        });
        const isError = status >= HttpStatusCode.BadRequest ||
            isErrorResponse({ status, response: originalResponse, url, headers: responseHeader });
        if (isError) {
            throw ((_b = transformError === null || transformError === void 0 ? void 0 : transformError(originalResponse, status, url, responseHeader)) !== null && _b !== void 0 ? _b : {
                mapped: [{ code: 'NoErrorCodeMapping' }],
                status,
                originalResponse: originalResponse,
            });
        }
        const transformedData = transformResponse ? transformResponse(originalResponse, responseHeader) : originalResponse;
        validate({
            requestId,
            validationMode,
            url,
            validationSchema: responseSchema,
            code: 'InvalidResponseSchema',
            data: transformedData,
            transformedData,
            status,
        });
        return transformedData;
    });
}
